{
  "name": "@mcpjam/cli",
  "version": "5.10.2",
  "description": "Test, debug, and validate MCP servers — health checks, OAuth conformance, tool-surface diffing, and structured triage from the terminal or CI",
  "type": "module",
  "main": "dist/index.js",
  "files": [
    "dist"
  ],
  "bin": {
    "mcpjam": "dist/index.js"
  },
  "scripts": {
    "build": "tsup",
    "bundle:skills": "node scripts/generate-skills-bundle.mjs",
    "test": "npm run build -w @mcpjam/sdk && npm run test:fast",
    "pretest:fast": "npm run build",
    "test:fast": "node scripts/run-tests.mjs",
    "typecheck": "tsc --noEmit",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@mcpjam/sdk": "^8.11.1",
    "@modelcontextprotocol/server": "2.0.0",
    "commander": "^14.0.3",
    "posthog-node": "^5.24.10",
    "ws": "^8.18.0",
    "zod": "^4.2.0"
  },
  "devDependencies": {
    "@modelcontextprotocol/client": "2.0.0",
    "@types/node": "^24.0.0",
    "@types/ws": "^8.18.1",
    "tsup": "^8.3.5",
    "tsx": "^4.23.12",
    "typescript": "^5.8.3"
  },
  "keywords": [
    "mcp",
    "model-context-protocol",
    "oauth",
    "conformance",
    "cli",
    "testing",
    "debugging",
    "health-check",
    "ci"
  ],
  "engines": {
    "node": ">=20.0.0"
  }
}
